module.exports = __webpack_public_path__ + "img/SAM_0042.c3dd0e37.jpeg";